import React from "react";
import Typewriter from "typewriter-effect";
import { usePortfolioSettings } from "../../hooks/usePortfolioData";

function Type() {
  const { settings } = usePortfolioSettings();

  // Parse job roles from comma-separated string, fallback to defaults
  const getJobRoles = () => {
    const rolesString = settings?.home_job_roles || 'Junior IoT Developer,Backend Developer,AI Enthusiast';
    if (!rolesString || rolesString.trim() === '') {
      return ['Junior IoT Developer', 'Backend Developer', 'AI Enthusiast'];
    }
    return rolesString.split(',').map(role => role.trim()).filter(role => role.length > 0);
  };

  const jobRoles = getJobRoles();

  return (
    <Typewriter
      options={{
        strings: jobRoles.length > 0 ? jobRoles : ['Developer'],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
